import { COLOR_KEYS } from '../../../constants';
import { ResourcesSectionProps } from './ResourcesSection';

export const DEFAULT_VALUES: ResourcesSectionProps = {
  backgroundColor: COLOR_KEYS.cream,
  heading: 'As much (or as little) help as you want',
  groups: [
    {
      heading: 'Do it yourself',
      description:
        '<p>Whether you’re brand-new to automation or looking to grow your skills, we make DIY doable.</p>',
      links: [
        {
          text: 'Quick start guide',
          url: 'https://zapier.com/learn/zapier-quick-start-guide/',
        },
        { text: 'Zapier University', url: 'https://zapier.com/university' },
        { text: 'Community', url: 'https://community.zapier.com/' },
        { text: 'Support', url: 'https://zapier.com/help' },
      ],
    },
    {
      heading: 'Hire an Expert',
      description:
        '<p>Choose a Zapier Certified Expert to help you think through and create automated workflows.</p>',
      links: [
        {
          text: 'Andy Wingrave',
          url: 'https://zapier.com/experts/andy-wingrave',
          showRating: true,
        },
        {
          text: 'MercOlogy',
          url: 'https://zapier.com/experts/mercology',
          showRating: true,
        },
        {
          text: 'GetUWired',
          url: 'https://zapier.com/experts/getuwired',
          showRating: true,
        },
        { text: 'See all Experts', url: 'https://zapier.com/experts' },
      ],
    },
  ],
};
